class AlpHeader extends HTMLElement {
  constructor() {
    super();
    this.headerEl = null;
    this.headerWrapperEl = null;
    this.navigationEL = null;
    this.menuOpen = false;
    this.togglerEl = null;
    this.menuLabelEl = null;
  }

  manageBodyScroll() {
    const body = document.body;

    if (this.menuOpen) {
      const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');

      body.classList.add('nav-opened');
      body.style.top = `-${scrollY}`;
    } else {
      const scrollY = body.style.top;
      window.scrollTo(0, parseInt(scrollY || '0') * -1);
      body.classList.remove('nav-opened');
      body.style.top = '';
    }
  }

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
    const toggleClasses = this.togglerEl.classList;
    const toggleDataset = this.togglerEl.dataset;
    const navigationClasses = this.navigationEL.classList;

    if (this.menuOpen) {
      // Animate lines & open main navigation
      toggleClasses.add('open');
      navigationClasses.add('open');
      navigationClasses.remove('close');

      // Change label
      this.menuLabelEl.innerText = toggleDataset.labelOpened;
    } else {
      toggleClasses.remove('open');
      navigationClasses.remove('open');
      navigationClasses.add('close');

      this.menuLabelEl.innerText = toggleDataset.labelClosed;
    }

    this.onScrollHandler(this.menuOpen);
    this.manageBodyScroll();
  }

  setHeaderState(isOpen) {
    const headerWrapperClasses = this.headerWrapperEl.classList;
    const headerClasses = this.headerEl.classList;
    const headerTheme = this.headerEl.dataset.theme;

    if (isOpen) {
      headerWrapperClasses.add('open');
      headerWrapperClasses.remove('close');

      // Change theme
      headerClasses.remove(headerTheme);
      headerClasses.add('light');
    } else {
      headerWrapperClasses.remove('open');
      headerWrapperClasses.add('close');

      // Change theme
      headerClasses.remove('light');
      headerClasses.add(headerTheme);
    }
  }

  onScrollHandler(isMenuOpen) {
    document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
    const scrollTop = window.scrollY || document.documentElement.scrollTop;

    this.setHeaderState(isMenuOpen || scrollTop > 30);
  }

  init() {
    this.togglerEl = this.querySelector('.menu-toggle');
    this.navigationEL = this.querySelector('alp-navigation');
    this.headerEl = this.querySelector('header');
    this.headerWrapperEl = this.querySelector('.header-wrapper');

    if (this.togglerEl) {
      this.menuLabelEl = this.togglerEl.querySelector('.menu-label');
      this.togglerEl.addEventListener('click', this.toggleMenu.bind(this));
    }

    window.addEventListener('scroll', this.onScrollHandler.bind(this, undefined));
    this.onScrollHandler(undefined);
  }

  connectedCallback() {
    setTimeout(() => {
      this.init();
    }, 250);
  }
}

class AlpNavigation extends HTMLElement {
  constructor() {
    super();
  }

  onRollOver(currentItem) {
    const currentId = currentItem.dataset.id;

    // Set opacity 40 to other
    this.navItems.forEach((itemEl) => {
      if (itemEl.dataset.id !== currentId) {
        itemEl.classList.add('opacity-40');
      }
    });

    // Change image
    this.navImages.forEach((itemEl) => {
      if (itemEl.dataset.id !== currentId) {
        itemEl.classList.add('opacity-0');
        itemEl.classList.remove('opacity-100');
      } else {
        itemEl.classList.add('opacity-100');
        itemEl.classList.remove('opacity-0');
      }
    });
  }

  onRollOut(currentItem) {
    this.navItems.forEach((itemEl) => {
      itemEl.classList.remove('opacity-40');
    });

    this.navImages.forEach((itemEl) => {
      itemEl.classList.add('opacity-0');
      itemEl.classList.remove('opacity-100');

      if (itemEl.dataset.id === 'default') {
        itemEl.classList.add('opacity-100');
        itemEl.classList.remove('opacity-0');
      }
    });
  }

  init() {
    this.navItems = this.querySelectorAll('.nav-item');
    this.navItems.forEach((itemEl) => {
      itemEl.addEventListener('mouseover', this.onRollOver.bind(this, itemEl));
      itemEl.addEventListener('mouseout', this.onRollOut.bind(this));
    });
    this.navImages = this.querySelectorAll('.nav-image');
  }

  connectedCallback() {
    setTimeout(() => {
      this.init();
    });
  }
}

customElements.define('alp-header', AlpHeader);
customElements.define('alp-navigation', AlpNavigation);
